import { Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle, Plus } from 'react-feather'


import { LinearLoading } from 'common'

import { AdminDepositTable } from './AdminDepositTable'
import { ModalModule } from './MoldaDeposit'


const AdminFormStepDeposit = ({useFetchInit}) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { stepApplilication, formOpeningMode } = globalStates

    const { fetchAllDeposits:{loadingFetchDeposits} } = FetchData


    const { handleClickReturnStep, handleClickNextStep, handleClickShowModal } = Actions

return (
    <div className='content'>
        
        {loadingFetchDeposits && ( <LinearLoading /> )}
        <AdminDepositTable
            useFetchInit = {useFetchInit}
        />

        <ModalModule useFetchInit={useFetchInit} />
        <div className="text-center">
            {stepApplilication !== 0 && (
                <Button 
                    startIcon={<ArrowLeftCircle/>}
                    variant="contained"
                    type="button" 
                    onClick={handleClickReturnStep} 
                    sx={{ marginRight: 1, marginLeft: 1, background: "#ef8157" }}
                >
                    Volver
                </Button>
            )}
            <Button
                endIcon={<ArrowRightCircle/>}
                variant="contained"
                type="button"
                style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                onClick={handleClickNextStep}
            >       
                {stepApplilication === 4 ? 'Finalizar' : 'Continuar'}
            </Button>
        </div>
    </div>
)


}
export {
    AdminFormStepDeposit
}